export default "__VITE_ASSET__CR9cmUg0__"